import React from 'react'
import { t } from '../i18n'
import { useFollow } from '../State/Follow'
import { track } from '../Utils/analytics'
import { norm } from '../Utils/text'
import { CheckIcon, PlusIcon } from './Icons'

/* "+ Prati" / "✓ Pratiš" (spec 2, Dugmad):
   - variant="header": primary orange, then an outlined "✓ Pratiš" that unfollows
   - variant="list": secondary outlined, then plain grey "✓ Pratiš"
   kind: 'topic' ({ slug, title }), 'source' ({ slug, name }) or 'keyword' ({ title }).
   small: the compact header bar's size. entry: where it is, for analytics
   (topic_header, explore, search, empty_state, source_header, sources_list…);
   count7d: a keyword's stories in the last days, when known. */
export default function FollowButton({
  kind,
  item,
  variant = 'list',
  entry,
  count7d = null,
  onFollow,
  small = false,
}) {
  const follow = useFollow()
  if (!item) return null

  let following
  let toggle
  let name
  if (kind === 'source') {
    name = item.name
    following = follow.isSourceFollowed(item.slug)
    toggle = () => {
      const now = follow.toggleSource(item.slug)
      track(now ? 'source_follow' : 'source_unfollow', { source_slug: item.slug, entry })
      if (now) onFollow?.()
    }
  } else {
    name = item.title
    const existing =
      kind === 'topic' ? follow.followedTopic(item.slug) : follow.followedKeyword(item.title)
    following = Boolean(existing)
    toggle = () => {
      if (existing) {
        follow.removeTopic(existing.key)
        track('topic_unfollow', {
          ...(kind === 'topic' ? { topic_slug: item.slug } : { keyword: norm(item.title) }),
          is_custom: kind !== 'topic',
        })
        return
      }
      if (kind === 'topic') {
        follow.addTopic({ slug: item.slug, title: item.title })
        track('topic_follow', { topic_slug: item.slug, entry })
      } else {
        follow.addKeyword(item.title)
        if (entry === 'search') track('search_follow', { query_length: item.title.length })
        track('custom_topic_add', { keyword: norm(item.title), count_7d: count7d, entry })
      }
      onFollow?.()
    }
  }

  const label = following
    ? t(kind === 'source' ? 'follow.unfollowSource' : 'follow.unfollowTopic', { name })
    : t(kind === 'source' ? 'follow.followSource' : 'follow.followTopic', { name })

  const className = following
    ? variant === 'header'
      ? 'btn btn-secondary btn-following'
      : 'btn-plain btn-following'
    : variant === 'header'
    ? 'btn btn-primary'
    : 'btn btn-secondary'

  return (
    <button
      type="button"
      className={`${className} follow-button ${small ? 'btn-small' : ''}`}
      aria-pressed={following}
      aria-label={label}
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        toggle()
      }}
    >
      {following ? (
        <CheckIcon size={16} strokeWidth={2.5} />
      ) : (
        <PlusIcon size={16} strokeWidth={2.5} />
      )}
      <span>{following ? t('follow.following') : t('follow.follow')}</span>
    </button>
  )
}
